import classNames from 'classnames';
import React from 'react';
import { Icon } from 'ui';
import Date from './Date';
import withComputedProps from './withComputedProps';

const DueDateBadge = ({ progress, isCompleted, isOverdue, rounded }) => (
  <div
    className={classNames(
      'LearnContentCardDueDateBadge',
      rounded && 'LearnContentCardDueDateBadge--rounded',
      isOverdue && 'LearnContentCardDueDateBadge--overdue',
      isCompleted && 'LearnContentCardDueDateBadge--completed',
    )}
  >
    {isOverdue && <span>{t('assignments.overdue.label')}</span>}
    {!isCompleted && progress.dueDate && !isOverdue && (
      <span>
        {t('assignments.due')} <Date>{progress.dueDate}</Date>
      </span>
    )}
    {isCompleted && (
      <span>
        <Icon name="completed" className="" />
        <Date>{progress.completedDate}</Date>
      </span>
    )}
  </div>
);

export default withComputedProps(DueDateBadge);
